export default {
  // 登录信息
  USERINFO: (state, data) => {
    state.userInfo = data;
    localStorage.setItem('userInfo', JSON.stringify(data || {}));
  },
  TIMEZONE: (state, data) => {
    state.timeZone = data;
    localStorage.setItem('timeZone', data);
  },
  TIMEZONEID: (state, data) => {
    state.timeZoneId = data;
    localStorage.setItem('timeZoneId', data);
  },
  DATEFORMAT: (state, data) => {
    state.dateFormat = data;
    localStorage.setItem('dateFormat', data);
  },
  ISTIME24H: (state, data) => {
    state.isTime24h = `${data}`;
    localStorage.setItem('isTime24h', `${data}`);
  },
  // 退出
  LOGINOUT: (state) => {
    state.userInfo = {};
    localStorage.removeItem('userInfo');
  },
  // 按钮权限
  MENUOBJ: (state, data) => {
    state.menuObj = data;
  },
  // 功能
  FUNCVIEW: (state, data) => {
    state.funcView = data;
  },
  // WebSocket消息条数
  MESSAGEWS: (state, data = 0) => {
    state.messageNum = data;
  },
};
